import type { HotelDetailsCancellationView } from '../models.js';

export function HotelDetailsCancellation({
  heading,
  cancellation,
}: {
  readonly heading: string;
  readonly cancellation: HotelDetailsCancellationView;
}) {
  const { headline, tone, rateLabel, windows, noteLabel } = cancellation;

  return (
    <section className="genui2 hui-hotel-details-cancellation">
      <h3>{heading}</h3>
      <p className="hui-hotel-details-cancellation-headline" data-tone={tone}>
        {headline}
      </p>
      {rateLabel && <p className="hui-hotel-details-cancellation-rate">{rateLabel}</p>}
      {windows.length > 0 && (
        <ul className="hui-hotel-details-cancellation-windows">
          {windows.map((window) => (
            <li key={window.id}>
              <span className="hui-hotel-details-cancellation-window-label">{window.label}</span>
              {window.detailLabel && (
                <span className="hui-hotel-details-cancellation-window-detail">
                  {window.detailLabel}
                </span>
              )}
            </li>
          ))}
        </ul>
      )}
      {noteLabel && <p className="hui-hotel-details-cancellation-note">{noteLabel}</p>}
    </section>
  );
}
